import { LogLevel } from '@azure/msal-browser';
/**
 * Configuration object to be passed to MSAL instance on creation.
 */
export const msalConfig = {
	auth: {
		clientId: (process.env.REACT_APP_CLIENT_ID as string) || ' ',
		authority: (process.env.REACT_APP_TENANT_ID as string) || ' ',
		redirectUri: (process.env.REACT_APP_REDIRECTURL as string) || ' ',
		postLogoutRedirectUri:
			(process.env.REACT_APP_LOGOUT_REDIRECTURL as string) || '',
		navigateToLoginRequestUrl: false,
	},
	cache: {
		cacheLocation: 'localStorage',
		storeAuthStateInCookie: false,
	},
	system: {
		loggerOptions: {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			loggerCallback: (level: any, message: any, containsPii: any) => {
				if (containsPii || !(process.env.NODE_ENV === 'development')) {
					return;
				}
				switch (level) {
					case LogLevel.Error:
						console.error(message);
						return;
					case LogLevel.Info:
						console.info(message);
						return;
					case LogLevel.Verbose:
						console.debug(message);
						return;
					case LogLevel.Warning:
						console.warn(message);
						return;
					default:
						return;
				}
			},
		},
		allowNativeBroker: false,
	},
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 */
export const loginRequest = {
	scopes: [(process.env.REACT_APP_SCOPES as string) || ''],
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
	scopes: [(process.env.REACT_APP_SCOPES as string) || ''],
	loginHint: 'example@domain.net',
};
